import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Logo from '../../ui/Logo/Logo.jsx';
import Button from '../../ui/Button/Button.jsx';
import styles from './Navbar.module.css';

// Labels match the reference design. "Work" and "Solutions" both point at
// the Solutions page for now — swap Work's `to` if a dedicated case-study
// / portfolio page is added later.
const links = [
  { to: '/solutions', label: 'Solutions' },
  { to: '/solutions', label: 'Work' },
  { to: '/plans', label: 'Pricing' },
  { to: '/insights', label: 'Insights' },
  { to: '/company', label: 'About Us' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`${styles.header} ${scrolled ? styles.scrolled : ''}`}>
      <div className="container">
        <div className={styles.bar}>
          <NavLink to="/" className={styles.logoLink} onClick={() => setOpen(false)}>
            <Logo size={30} />
          </NavLink>

          <nav className={`${styles.nav} ${open ? styles.navOpen : ''}`}>
            {links.map((l, i) => (
              <NavLink
                key={l.label}
                to={l.to}
                end={l.to === '/'}
                className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
                onClick={() => setOpen(false)}
              >
                {l.label}
              </NavLink>
            ))}
            <div className={styles.mobileCta}>
              <Button to="/contact" variant="primary" size="md">
                Get Started <ArrowRight size={16} />
              </Button>
            </div>
          </nav>

          <div className={styles.actions}>
            <Button to="/contact" variant="primary" size="md">
              Get Started <ArrowRight size={16} />
            </Button>
          </div>

          <button
            className={`${styles.burger} ${open ? styles.burgerOpen : ''}`}
            aria-label="Toggle navigation"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span /><span /><span />
          </button>
        </div>
      </div>
    </header>
  );
}
